import { formatAddressText } from '~/utils/addressFormat';
import type { BuyListRecord } from './buyListSummaryCells';

export function BuyListLocation({
  buyList,
  testId,
  isLink = false,
}: Readonly<{
  buyList: BuyListRecord;
  testId: string;
  isLink?: boolean;
}>) {
  const address = formatAddressText(buyList.location.facility.address);

  return (
    <span
      className="flex flex-col items-start gap-0.5 text-left"
      data-testid={`${testId}-location-${buyList.id}`}
    >
      <span
        className={`font-medium text-neut-prim ${isLink ? 'group-hover:text-prim transition-colors' : ''}`}
      >
        {buyList.location.code}
      </span>
      {address && (
        <span
          className="text-xs text-neut-sec"
          data-testid={`${testId}-address-${buyList.id}`}
        >
          {address}
        </span>
      )}
    </span>
  );
}
